import { useEffect, useState } from "react";
import "../App.css";
import "../Backgrounds.css";
import "./Home.css";
import MainHeader from "../components/MainHeader";
import Footer from "../components/Footer";
import AdaptiveMusicPlayer from "../components/AdaptiveMusicPlayer";

const AdaptiveMusic = () => {
  const [showDevView, setShowDevView] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="foreground">
        <MainHeader />

        <div className="homeBackground">
          <div className="homeContentContainer">
            <div className="block">
              <h1
                style={{
                  color: "var(--font-colour-content1)",
                  textAlign: "center",
                }}
              >
                Adaptive Music Sandbox
              </h1>
              <p
                style={{
                  color: "var(--font-colour-content2)",
                  textAlign: "center",
                }}
              >
                Experimental space for Tone.js adaptive music components
              </p>

              <div style={{ marginBottom: "20px", textAlign: "center" }}>
                <label
                  style={{
                    color: "var(--font-colour-content2)",
                    cursor: "pointer",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={showDevView}
                    onChange={(e) => setShowDevView(e.target.checked)}
                    style={{ marginRight: "8px" }}
                  />
                  Show Dev View
                </label>
              </div>

              <AdaptiveMusicPlayer showDevView={showDevView} />
            </div>

            <div className="solidLine"></div>

            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdaptiveMusic;
